import React from "react";
import { Card, Tabs, Spin } from "antd";
import { useQuery, gql } from "@apollo/client";
import "../powerBIReports/itReports.css";

const { TabPane } = Tabs;

// New GraphQL Query using getReportsApi
const GET_REPORTS = gql`
  query {
    getReportsApi {
      id
      name
      powerBiReport
    }
  }
`;

const AdminITReports = () => {
  const { data, loading, error } = useQuery(GET_REPORTS);

  if (loading)
    return (
      <div style={{ width: "100%", height: "90vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" />
      </div>
    );

  if (error) return <p style={{ color: "red" }}>Error loading reports</p>;

  // Extract the array from getReportsApi
  const reports = data?.getReportsApi || [];

  return (
    <div
      style={{
        width: "95vw",
        height: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "57px",
      }}
      className="it-reports-container"
    >
      <Card style={{ width: "100vw", height: "100vh", padding: 0 }}>
        <label
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "16px",
            fontFamily: "Inter",
          }}
        >
          Reports
        </label>

        <Tabs defaultActiveKey="1" style={{ height: "100%" }}>
          {reports.map((report) => (
            <TabPane tab={report.name} key={report.id}>
              <iframe
                src={report.powerBiReport}
                title={report.name}
                style={{ width: "100%", height: "85vh", border: "none" }}
                allowFullScreen
              />
            </TabPane>
          ))}
        </Tabs>
      </Card>
    </div>
  );
};

export default AdminITReports;